import { useQuery } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { usePortalUserStore } from "@/app/stores";
import type { Patient } from "@/shared/models/legacy-types";

export const usePatientQuery = <TSelect = Patient>(
  select?: (data: Patient) => TSelect,
) => {
  const hasPatientId = usePortalUserStore((state) =>
    Boolean(state.portalUser?.patientId),
  );

  return useQuery({
    ...appQueriesStore.patient,
    enabled: hasPatientId,
    staleTime: Infinity,
    select,
  });
};
